import $api from "../api";

var DEFAULT_COLORS = {
    early_bird: '#6F42C1',
    local: '#28A745',
    national: '#FFC107',
    late_born: '#ADB5BD',
    genesis: '#0DCAF0',
};

export const state = {
    active: Object.assign({ year: null }, DEFAULT_COLORS),
    allConfigs: [],
    logs: [],
};

export const actions = {
    fetchActive({ commit, rootGetters }) {
        return new Promise(function (resolve) {
            $api
                .get('season-colors/active', {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status === 200 && res.data.data) {
                        commit("setActive", res.data.data);
                        resolve(res.data.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function () {
                    resolve(null);
                });
        });
    },
    fetchAll({ commit, rootGetters }) {
        return new Promise(function (resolve) {
            $api
                .get('admin/season-colors', {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status === 200) {
                        commit("setAllConfigs", res.data.data);
                        resolve(res.data.data);
                    }
                })
                .catch(function () {
                    resolve([]);
                });
        });
    },
    save({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .post('admin/season-colors', pl, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status === 200 || res.status === 201) resolve(res.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    resolve(err.response.data);
                });
        });
    },
    activate({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .post('admin/season-colors/activate', pl, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status === 200 || res.status === 201) resolve(res.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    resolve(err.response.data);
                });
        });
    },
    updateYear({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .put('admin/season-colors/' + pl.old_year + '/year', { year: pl.year }, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status === 200 || res.status === 201) resolve(res.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    resolve(err.response.data);
                });
        });
    },
    fetchLogs({ commit, rootGetters }) {
        return new Promise(function (resolve) {
            $api
                .get('admin/season-colors/logs', {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                })
                .then(function (res) {
                    if (res.status === 200) {
                        commit("setLogs", res.data.data);
                        resolve(res.data.data);
                    }
                })
                .catch(function () {
                    resolve([]);
                });
        });
    },
};

export const mutations = {
    setActive(state, data) {
        if (!data) return;
        state.active = {
            year: data.year || null,
            early_bird: data.early_bird || DEFAULT_COLORS.early_bird,
            local: data.local || DEFAULT_COLORS.local,
            national: data.national || DEFAULT_COLORS.national,
            late_born: data.late_born || DEFAULT_COLORS.late_born,
            genesis: data.genesis || DEFAULT_COLORS.genesis,
        };
    },
    setAllConfigs(state, data) {
        state.allConfigs = data || [];
    },
    setLogs(state, data) {
        state.logs = data || [];
    },
};

export const getters = {
    colors: function (state) {
        return state.active;
    },
    allConfigs: function (state) {
        return state.allConfigs;
    },
    logs: function (state) {
        return state.logs;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
